import axios from 'axios';
import { COMUNAS, PUBLIC } from '../utils/constantes/constantesAuthInterceptor';

const mostrarLoading = () => {
  let contador: string | number | null = sessionStorage.getItem('loading');
  contador = parseInt(contador!, 10) + 1;
  sessionStorage.setItem('loading', contador.toString());

  const loading = document.getElementById('loading');
  if (loading) {
    loading.classList.add('backdrop--show');
  }
};

const AuthInterceptor = () => {
  axios.interceptors.request.use(request => {
    const apiKey = `${process.env.REACT_APP_HEADER_API_KEY}`;
    const token = localStorage.getItem('token');

    request.headers['x-api-key'] = apiKey;

    // No agregar token para peticiones del servicio de comunas o publicas
    const esServicioComunas = request.url?.includes(COMUNAS);
    const esServicioPublico = request.url?.includes(PUBLIC);

    if (token !== null && token !== '' && !esServicioComunas && !esServicioPublico) {
      request.headers.Authorization = `Bearer ${token}`;
    }

    mostrarLoading();
    return request;
  });
};

export default AuthInterceptor;
